import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { IPayCategory, IPayCategoryHistory } from '../../pay-categories.type';

/**
 * Handles display of dump card
 */
@Component({
	selector: 'app-category-card',
	styleUrls: ['./category-card.component.scss'],
	templateUrl: './category-card.component.html'
})
export class CategoryCardComponent implements OnInit {
	constructor(private router: Router) {}

	@Input() public onlyArchived: boolean = false;
	@Input() public payCategory: IPayCategory;
	@Input() public idPrefix: string;
	public isPayCategoryArchived: boolean = false;
	public selectedCategory: string = '';

	public ngOnInit(): void {
		if (!this.payCategory) {
			return;
		}

		this.isPayCategoryArchived = this.checkIfPayCategoryArchived();
	}

	public navigate = (category: string, catType: string = 'new', date: string = 'now'): void => {
		this.router
			.navigate(['/pilotpay/pay-categories', category, catType, date])
			.then(() => {
				this.selectedCategory = category;
			})
			.catch((err: Error) => {
				console.error(err);
			});
	};

	private checkIfPayCategoryArchived(): boolean {
		return !!(
			this.payCategory.scheduledChanges &&
			this.payCategory.scheduledChanges.filter((change: IPayCategoryHistory) => change.isPayCategoryArchived)
				.length
		);
	}
}
